/**
 * Created by Mikhail Menshenin on 29.05.2025
 */

Snapshots.prototype.importFromUrl = function (callback) {
    const url = prompt("enter snapshot url");

    let id = url && url.replace(/.*snapshot=([^&#]+).*/, "$1");
    if (id === url) {
        id = url && url.replace(/.*aisensia.com\/([A-Za-z0-9]+).*/, "$1");
    }
    if (!id) {
        return;
    }

    if (id.indexOf("/") !== -1) {
        this.getSnapshotFromUrl(`https://${id}`, callback);
        return;
    }

    this.getSnapshot(id, (snapshot) => {
        callback(snapshot);
    });
};
